<template>
    <div>
        uitloggen..
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    created() {
        this.logout().then(() => {
            this.$router.push({
                name: 'home'
            });
        }, () => {
            this.$router.push({
                name: 'home'
            });
        });
    },
    methods: {
        ...mapActions({
            'logout': 'sportid/logout'
        }),
    }
};
</script>
